import { useCallback, useMemo, useState } from "react";
import { isIOS, isPwaInstalled } from "../utils/platform";

export const PUSH_PRIMER_SHOWN_KEY = "inssa:push:primerShownOnce";

function getNotificationPermission() {
  if (typeof Notification === "undefined") return "unsupported";
  return Notification.permission || "default";
}

function hasShownPushPrimer() {
  try {
    return localStorage.getItem(PUSH_PRIMER_SHOWN_KEY) === "1";
  } catch {
    return false;
  }
}

function markPushPrimerShown() {
  try {
    localStorage.setItem(PUSH_PRIMER_SHOWN_KEY, "1");
  } catch {
    // ignore storage failures; the primer still closes for this session
  }
}

export default function usePushPermissionPrimer() {
  const [pushPrimerOpen, setPushPrimerOpen] = useState(false);
  const [shownOnce, setShownOnce] = useState(() => hasShownPushPrimer());

  const canUsePushPrimer = useMemo(() => {
    return isIOS() && isPwaInstalled();
  }, []);

  const canOfferPushPrimer = useMemo(() => {
    return (
      canUsePushPrimer &&
      getNotificationPermission() === "default" &&
      !shownOnce
    );
  }, [canUsePushPrimer, shownOnce]);

  const queuePushPrimer = useCallback(() => {
    if (!canOfferPushPrimer) return;
    setPushPrimerOpen(true);
  }, [canOfferPushPrimer]);

  const closePushPrimer = useCallback(() => {
    markPushPrimerShown();
    setShownOnce(true);
    setPushPrimerOpen(false);
  }, []);

  const requestPushNotifications = useCallback(() => {
    markPushPrimerShown();
    setShownOnce(true);
    setPushPrimerOpen(false);
    window.dispatchEvent(new Event("inssa:request-notifications"));
  }, []);

  return {
    canOfferPushPrimer,
    pushPrimerOpen,
    queuePushPrimer,
    closePushPrimer,
    requestPushNotifications,
  };
}
